import React, { Component } from "react";
import ContainerRightG from "./ContainerRightG";

class ContainerLeft extends Component {
  render() {
    return (
      <div
        className="col-left animate-element wow delay5 fadeInDown"
        data-wow-delay="0.5s"
      >
        <div className="flat-title t1">
          <h4 className="sub-title mb-2">Have a look to what I built so far</h4>
          <h2 className="title-section color-d12 mg-b34">
            I developed 2 commercial websites using HTML, CSS and React.js
          </h2>
      
        </div>
      <div className="dnon">
      <ContainerRightG/>
      </div>
       
      </div>
      
    );
  }
}

export default ContainerLeft;
